import { FC } from 'react';
import Image from 'next/image';

export const FundCoverBackground: FC = ({}) => {
  return (
    <div className="absolute left-0 top-0">
      <Image
        alt="صندوق"
        className="z-[1]"
        height={143}
        src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/fund/vault.svg"
        width={201}
        priority
      />
    </div>
  );
};
